import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routers'
import store from '@/store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes
})

const HOME_PAGE_NAME = '/'

router.beforeEach((to, from, next) => {
  store.commit('HEAD_BOX_600', !(to.path === HOME_PAGE_NAME))
  store.commit('top_400', !(to.path === HOME_PAGE_NAME))
  /* 路由发生变化修改页面title */
  if (to.meta.metaInfo) {
    store.commit('CHANGE_META_INFO', to.meta.metaInfo)
  }

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js